import React from 'react';
import SingleSelectFilter from '~/components/filters/SingleSelectFilter';

const options = [
  { id: 'active', name: 'Yes' },
  { id: 'inactive', name: 'No' },
];

export default function PlaceholderStatusFilter(props) {
  return (
    <SingleSelectFilter
      placeholder="Placeholder Active"
      renderValue={(value) => value.name}
      options={options}
      {...props}
    />
  );
}
